export default __webpack_public_path__ + "static/media/details-inline.3e7bcdda.svg";